"use client";

import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";
import type { PageSearchParams } from "types/page";

import { useMarket } from "@features/market/useMarket";
import { useVariantSelector } from "../hooks/useVariantSelector";
import type { VariantCatalog } from "../types";
import VariantSelect from "./VariantSelect";

type VariantSelectorProps = {
  catalog: VariantCatalog;
  searchParams?: PageSearchParams;
} & ComponentProps<"div">;

export default function VariantSelector(props: VariantSelectorProps) {
  const { catalog, searchParams, className, ...rest } = props;
  const { locale } = useMarket();
  const { attributes, onSelect } = useVariantSelector(
    catalog,
    locale,
    searchParams,
  );

  if (!attributes.length) return null;

  return (
    <div
      className={cn("relative flex flex-col gap-4", className)}
      data-testid="ProductVariantSelect"
      {...rest}
    >
      {attributes.map((attribute, index) => (
        <VariantSelect
          key={attribute.code}
          code={attribute.code}
          label={attribute.label}
          value={attribute.value}
          options={attribute.options}
          locale={locale}
          onValueChange={(value) => onSelect(index, value)}
        />
      ))}
    </div>
  );
}
